package fr.manyverse.app.domain.usecase

import fr.manyverse.app.domain.error.ValidationError
import fr.manyverse.app.domain.model.User
import fr.manyverse.app.domain.repository.AuthRepository
import fr.manyverse.app.domain.validation.EmailValidator

class VerifyOtpUseCase(private val authRepository: AuthRepository) {
    suspend operator fun invoke(email: String, token: String): Result<User> {
        EmailValidator.validate(email).onFailure {
            return Result.failure(it)
        }
        if (token.isBlank() || token.length != 6 || !token.all { it.isDigit() }) {
            return Result.failure(ValidationError("OTP must be a 6-digit code"))
        }
        return authRepository.verifyEmailOtp(email, token)
    }
}
